import { createStore } from 'vuex'
import auth from './modules/auth'
import app from './modules/app'
import user from './modules/user'

const store = createStore({
    modules: {
        auth,
        app,
        user
    },

    // 严格模式，在开发环境下启用
    strict: process.env.NODE_ENV === 'development',

    // 根状态
    state: {
        version: '1.0.0'
    },

    // 根getter
    getters: {
        version: state => state.version
    },

    // 根mutations
    mutations: {
        // 可以在这里添加全局mutations
    },

    // 根actions
    actions: {
        // 初始化应用
        async initApp({ dispatch }) {
            console.log('🚀 初始化Auth Portal应用...')

            try {
                // 检查认证状态
                await dispatch('auth/checkAuthStatus')

                // 初始化应用设置
                await dispatch('app/initSettings')

                console.log('✅ 应用初始化完成')
            } catch (error) {
                console.error('❌ 应用初始化失败:', error)
                throw error
            }
        },

        // 清理应用状态
        async clearAppState({ commit }) {
            commit('auth/CLEAR_AUTH_DATA')
            commit('user/CLEAR_USER_DATA')
            commit('app/RESET_SETTINGS')
        }
    }
})

export default store 